export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15158.06b79424.jpg";